import { Action } from '@ngrx/store';

import { Question } from '../../shared/question.model';

export const ADD_QUESTION = 'ADD_QUESTION';
export const ADD_QUESTIONS = 'ADD_QUESTIONS';
export const UPDATE_QUESTION = 'UPDATE_QUESTION';
export const DELETE_QUESTION = 'DELETE_QUESTION';
export const FETCH_QUESTIONS = 'FETCH_QUESTIONS';
export const STORE_QUESTIONS = 'STORE_QUESTIONS';
export const START_EDIT = 'START_EDIT';
export const STOP_EDIT = 'STOP_EDIT';

export class AddQuestion implements Action {
  readonly type = ADD_QUESTION;

  constructor(public payload: Question) {}
}

export class AddQuestions implements Action {
  readonly type = ADD_QUESTIONS;

  constructor(public payload: Question[]) {}
}

export class UpdateQuestion implements Action {
  readonly type = UPDATE_QUESTION;

  constructor(public payload: {question: Question}) {}
}

export class DeleteQuestion implements Action {
  readonly type = DELETE_QUESTION;
}

export class FetchQuestions implements Action {
  readonly type = FETCH_QUESTIONS;
}

export class StoreQuestions implements Action {
  readonly type = STORE_QUESTIONS;
}

export class StartEdit implements Action {
  readonly type = START_EDIT;

  constructor(public payload: number) {}
}

export class StopEdit implements Action {
  readonly type = STOP_EDIT;
}

export type QuestionListActions =
  AddQuestion |
  AddQuestions |
  UpdateQuestion |
  DeleteQuestion |
  FetchQuestions |
  StoreQuestions |
  StartEdit |
  StopEdit;



// WEBPACK FOOTER //
// ./src/app/question-list/store/question-list.actions.ts